import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "animate-pulse" }, [
      _createElementVNode("div", { class: "mt-4 h-4 w-full rounded-md bg-gray-200" }),
      _createElementVNode("div", { class: "mx-auto mt-4 h-4 w-1/2 rounded-md bg-gray-200" })
    ], -1)
  ]))]))
}